import {useUserToken, useValidateUserToken} from '@aboutyou/user';
import React, {useEffect} from 'react';
import {useSubscribeToWhatsappNewsletter} from './hooks/useSubscribeToWhatsappNewsletter';

export const SubscribeToWhatsappNewsletter: React.FC<{
  whatsappUUIDToken: string;
  countryCode: string;
}> = ({whatsappUUIDToken, countryCode}) => {
  const {data} = useValidateUserToken();
  const authToken = useUserToken();
  const subscribeToWhatsappNewsletterCallback =
    useSubscribeToWhatsappNewsletter();

  useEffect(() => {
    if (data?.isValid) {
      subscribeToWhatsappNewsletterCallback(
        authToken!,
        whatsappUUIDToken,
        countryCode,
      );
    }
  }, [data?.isValid]);

  return null;
};
